
<template>
	<div class="dateTime">
		<div class="date">{{ date }}</div>
		<div v-if="!onlyDay" class="time">{{ time }}</div>
	</div>
</template>

<script>
import parseDateTime from "@/helper/parseDateTime";

export default {
	name: "DateTime",
	props: {
		item: { type: Object, default: () => ({}) },
		line: { type: Object, default: () => ({}) },
		onlyDay: { type: Boolean, default: false },
	},
	computed: {
		rawValue() {
			return this.line?.[this.item?.value] ?? null;
		},

		dateTimeParse() {
			return this.rawValue ? parseDateTime(this.rawValue) : null;
		},

		date() {
			return this.dateTimeParse?.date ?? '';
		},

		time() {
			return this.dateTimeParse?.timeWithoutSeconds ?? '';
		}
	}
};
</script>

<style scoped lang="scss">
.dateTime {
	.date {
		color: var(--card-color);
	}
	.time {
		color: var(--card-color-sub-title);
		font-size: 12px;
	}
}

</style>
